import { createContext, type MutableRefObject, type ReactNode, useRef, useState } from "react";

export const CanvasContext = createContext<{
    parentImageRef: MutableRefObject<HTMLImageElement | null> | null;
    resizeRef: MutableRefObject<HTMLImageElement | null> | null;
    cropRef: MutableRefObject<HTMLImageElement | null> | null;
    flipRef: MutableRefObject<HTMLImageElement | null> | null;
    rotateRef: MutableRefObject<HTMLImageElement | null> | null;
    initialImageRef: MutableRefObject<HTMLImageElement | null> | null;
    imageLoaded: boolean;
    setImageLoaded: (value: boolean) => void;
}>({
    parentImageRef: null,
    resizeRef: null,
    cropRef: null,
    flipRef: null,
    rotateRef: null,
    initialImageRef: null,
    imageLoaded: false,
    setImageLoaded: () => {},
});

export const CanvasProvider = ({ children }: { children: ReactNode }) => {
    const parentImageRef = useRef<HTMLImageElement | null>(null);
    const resizeRef = useRef<HTMLImageElement | null>(null);
    const cropRef = useRef<HTMLImageElement | null>(null);
    const flipRef = useRef<HTMLImageElement | null>(null);
    const rotateRef = useRef<HTMLImageElement | null>(null);
    const initialImageRef = useRef<HTMLImageElement | null>(null);
    const [imageLoaded, setImageLoaded] = useState(false);

    return (
        <CanvasContext.Provider
            value={{
                parentImageRef,
                resizeRef,
                cropRef,
                flipRef,
                rotateRef,
                imageLoaded,
                setImageLoaded,
                initialImageRef,
            }}
        >
            {children}
        </CanvasContext.Provider>
    );
};
